import React from "react";
import "../../assets/css/screens/customer/dashboard/profile/profile.css";
// import AppNavbar from "../../../../components/customer/dashboard/apphome/appnavbar/AppNavbar";
import AppNavbar from "../customer/dashboard/apphome/appnavbar/AppNavbar";

const ProfileSkeleton = () => {
  return (
    <>
      <AppNavbar />

      <div className="profile-page">

        {/* Header */}
        <div className="inbox-header">
          <div className="profile-sk-back skeleton"></div>
          <div className="profile-sk-title skeleton"></div>
        </div>

        {/* ================= Desktop ================= */}

        <div className="profile-desktop">

          {/* User Card */}

          <div className="profile-user-card">

            <div className="profile-avatar-wrapper">

              <div className="profile-sk-avatar skeleton"></div>

              <div className="profile-sk-edit skeleton"></div>

            </div>

            <div className="profile-sk-name skeleton"></div>

            <div className="profile-sk-email skeleton"></div>

            <div className="profile-sk-phone skeleton"></div>

            <div className="profile-stats">

              {[1,2,3].map((i)=>(

                <div className="profile-stat" key={i}>

                  <div className="profile-sk-stat-no skeleton"></div>

                  <div className="profile-sk-stat-text skeleton"></div>

                </div>

              ))}

            </div>

          </div>

          {/* Menu Grid */}

          <div className="profile-menu-grid">

            {[1,2,3,4,5,6,7].map((i)=>(

              <div
                className="profile-menu-card"
                key={i}
              >

                <div className="profile-sk-icon skeleton"></div>

                <div className="profile-sk-menu-title skeleton"></div>

                <div className="profile-sk-menu-sub skeleton"></div>

                <div className="profile-sk-arrow skeleton"></div>

              </div>

            ))}

          </div>

        </div>

        {/* ================= Mobile ================= */}

        <div className="profile-mobile">

          <div className="profile-mobile-user">

            <div className="profile-sk-avatar-mobile skeleton"></div>

            <div className="profile-mobile-info">

              <div className="profile-sk-name skeleton"></div>

              <div className="profile-sk-email skeleton"></div>

            </div>

            <div className="profile-sk-edit skeleton"></div>

          </div>

          {/* Stats */}

          <div className="profile-mobile-stats">

            {[1,2,3].map((i)=>(

              <div
                className="profile-mobile-stat"
                key={i}
              >

                <div className="profile-sk-stat-no skeleton"></div>

                <div className="profile-sk-stat-text skeleton"></div>

              </div>

            ))}

          </div>

          {/* Menu */}

          <div className="profile-mobile-menu">

            {[1,2,3,4,5,6,7,8,9].map((i)=>(

              <div
                className="profile-mobile-item"
                key={i}
              >

                <div className="profile-sk-mobile-icon skeleton"></div>

                <div
                  className="profile-sk-menu-title skeleton"
                  style={{flex:1}}
                ></div>

                <div className="profile-sk-arrow skeleton"></div>

              </div>

            ))}

          </div>

        </div>

      </div>

    </>
  );
};

export default ProfileSkeleton;